//@flow

import React, { useState } from "react";
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  Typography
} from "@material-ui/core";
import type { ChildrenNodeType } from "../../../types/licenceTypes";
import { ExpandMore } from "@material-ui/icons";
import LicenceList from "../LicenceList";
import { buildLicenceItemJson } from "../../companies/CompileCompanytoJson";
type LicenceCompanyListPropsType = {
  companies: ChildrenNodeType[]
};
export const LicenceCompanyList = (props: LicenceCompanyListPropsType) => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleCompanySelect =
    (id: string) => (event: React.ChangeEvent<{}>, expanded: boolean) => {
      setExpanded(expanded ? id : false);
    };

  const CompanyList = props.companies.map((comp, i) => {
    let company = comp.node;
    return (
      <ExpansionPanel
        expanded={expanded === company.id}
        onChange={handleCompanySelect(company.id)}
        key={`licence-company-${company.id}-${i}`}
      >
        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle1" className="heading">
            {company.name}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography variant="subtitle1" className="subheading">
            Licences
          </Typography>
          <LicenceList
            licences={company.licences.edges.map((l) =>
              buildLicenceItemJson(l.node)
            )}
            isForUser
            canEdit
          />
          {company.children && company.children.edges.length > 0 && (
            <>
              <Typography variant="subtitle1" className="subheading">
                {company.children.edges[0].node.companyType}
              </Typography>
              <LicenceCompanyList companies={company.children.edges} />
            </>
          )}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  });

  return (
    <div className="app-panel-content panel-top-margin">
      <Grid container spacing={24}>
        <Grid item xs={12}>
          {CompanyList}
        </Grid>
      </Grid>
    </div>
  );
};
